import { useEffect, useRef, useState } from "react";
import { decryptData, defaulUrl, impression, listeMois } from "../components/const";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const RapportPresence = () => {
    const currentDate = new Date();
    const [annee, setAnnee] = useState(currentDate.getFullYear())
    const [mois, setMois] = useState(currentDate.getMonth() + 1 < 10 ? `0${currentDate.getMonth() + 1}` : currentDate.getMonth() + 1)
    const toPrint = useRef();
    const [numberOfDays, setNumberOfDays] = useState(null);
    const [rapport, setRapport] = useState([]);
    const [load, setLoad] = useState(false)

    const handleShowRapport = () => {
        let status = 0;
        setLoad(true)
        fetch(`${defaulUrl}personnel/rapport-present/${annee}/${mois}`, {
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + decryptData('ACCESS_TOKEN'),
                Accept: 'application/json',
                "Content-Type": "application/json"
            },
        }).then((response) => {
            status = response.status;
            return response.json();
        }).then(data => {
            setLoad(false);
            if (status === 200) {
                data?.personnel?.sort((a, b) => b.nb_presence - a.nb_presence)
                setRapport(data?.personnel);
                setNumberOfDays(data?.nbjours)
            }
        })
    }

    useEffect(() => {
        handleShowRapport()
    }, [])

    // 🔹 Fonction PDF dynamique pour le rapport de présence
    const printRapportPresence = (title, tab = [], nbJours = 0) => {
        const user = decryptData("USER");

        if (!tab || tab.length === 0) {
            alert("Aucune donnée à imprimer !");
            return;
        }

        const doc = new jsPDF("landscape");

        // Entête PDF
        doc.setFontSize(18);
        doc.setTextColor(0, 123, 255);
        doc.text("FANSAN TEXTIL", 105, 20, { align: "center" });
        doc.setFontSize(14);
        doc.text(title?.toUpperCase() || "", 105, 30, { align: "center" });

        // Colonnes dynamiques
        const headers = ["PRENOMS & NOM"];
        for (let i = 1; i <= nbJours; i++) headers.push(i.toString());
        headers.push("T. PRE");

        // Préparer les données
        const data = tab.map((pers) => {
            const row = [
                pers?.nom?.toUpperCase() ?? "Pas de nom",
                ...Array.from({ length: nbJours }, (_, i) => {
                    const val = pers?.presences?.[i];
                    return val ? val.substring(0, 3) : "";
                }),
                pers?.nb_presence ?? 0
            ];
            return row;
        });

        autoTable(doc, {
            startY: 40,
            head: [headers],
            body: data,
            headStyles: { fillColor: [52, 58, 64], textColor: 255 },
            theme: "grid",
        });

        // Pied de page
        const pageHeight = doc.internal.pageSize.height;
        doc.setFontSize(10);
        doc.text(new Date().toLocaleDateString(), 105, pageHeight - 20, { align: "center" });
        doc.text(user?.droit?.toUpperCase() || "", 105, pageHeight - 10, { align: "center" });

        doc.save(`${title || "rapport_presence"}.pdf`);
    }

    return (
        <div className="rapport">
            {load && <div className="loader"></div>}
            <div className="row my-2 align-items-center">
                <div className="col-md-2 pe-1">
                    <div className="form-group">
                        <label htmlFor="" className="form-label">Années</label>
                        <select name="" className="form-select"
                            defaultValue={annee} onChange={(e) => setAnnee(e.target.value)}>
                            <option value="">Choisir une année</option>
                            <option value="2024">2024</option>
                            <option value="2025">2025</option>
                        </select>
                    </div>
                </div>
                <div className="col-md-2 text-start m-0 p-0">
                    <div className="form-group">
                        <label htmlFor="" className="form-label">Mois</label>
                        <div className="input-group">
                            <select className="form-select"
                                defaultValue={mois} onChange={(e) => setMois(e.target.value)}>
                                <option value="">Choisir un mois</option>
                                {listeMois.map(m => {
                                    const index = listeMois.indexOf(m) + 1 < 10 ? `0${listeMois.indexOf(m) + 1}` : listeMois.indexOf(m) + 1;
                                    return <option key={m} value={index}>{m}</option>
                                })}
                            </select>
                            <button className="btn btn-primary" onClick={handleShowRapport}><i className="bx bx-show"></i></button>
                        </div>
                    </div>
                </div>
            </div>

            {load ? <div className="loader"></div> :
                <>
                    <div className="text-end mb-2">
                        <button className="btn btn-primary w-auto"
                            onClick={() => printRapportPresence("Rapport de présence", rapport, numberOfDays)}>
                            <i className="bx bx-printer"></i>
                        </button>
                    </div>
                    <div className="table-responsive mt-3 small" ref={toPrint}>
                        <div className="h6 text-primary">LISTE DE PRESENCE PAR ORDRE D'ASSIDUITE</div>
                        <table className="table table-striped table-bordered">
                            <thead className="table-primary">
                                <tr className="align-middle text-center">
                                    <th>PRENOMS & NOM</th>
                                    {Array.from({ length: numberOfDays }, (_, index) => <th key={index} width="1%">{index + 1}</th>)}
                                    <th>T. PRE</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rapport?.map((pers, ind) => (
                                    <tr className="align-middle" key={ind}>
                                        <td>{(pers?.nom?.toUpperCase() ?? "Pas de nom")}</td>
                                        {pers?.presences?.map((p, i) => (
                                            <td key={i} className={p ? p === 'Présent' ? 'bg-success-subtle' : 'bg-danger-subtle' : ''}>
                                                {p?.substring(0, 3)}</td>
                                        ))}
                                        <td className="text-center">{pers?.nb_presence}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            }
        </div>
    );
}

export default RapportPresence;
